import parse from 'html-react-parser';

/**
 * Safely parses HTML content, handling invalid tag names (like email addresses in angle brackets)
 * that would cause createElement errors.
 * 
 * Pre-processes the HTML to escape invalid tag-like patterns before parsing.
 * 
 * @param html - The HTML string to parse
 * @returns React elements or the original string if parsing fails
 */
export function safeParseHtml(html: string): string | JSX.Element | JSX.Element[] {
    if (!html) return '';
    
    try {
        // Pre-process HTML to escape invalid tag-like patterns
        // This specifically targets email addresses in angle brackets and other invalid tag names
        const sanitized = html.replace(/<([^>\s]+@[^>\s]+)>/g, '&lt;$1&gt;');
        
        return parse(sanitized);
    } catch (error) {
        // If parsing fails completely, return the original string
        console.error('Error parsing HTML:', error);
        return html;
    }
}

